import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { SchedulingFeatureProvider } from "./context/SchedulingFeatureContext";
import LandingPage from "./components/LandingPage";
import LoginPage from "./components/LoginPage";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import VerifyEmail from "./components/VerifyEmail";
import BrowsePage from "./components/BrowsePage";
import SearchResults from "./components/SearchResults";
import SubscriptionPlans from "./components/SubscriptionPlans";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancel from "./components/PaymentCancel";
import AccountSettings from "./components/AccountSettings";
import AdminDashboard from "./components/admin/AdminDashboard";
import NetworkingPage from "./components/NetworkingPage";
import UserProfilePage from "./components/UserProfilePage";
import PricingPage from "./components/PricingPage";
import MessagesPage from "./components/MessagesPage";
import { Toaster } from "./components/ui/toaster";

// Protected Route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/browse" element={<ProtectedRoute><BrowsePage /></ProtectedRoute>} />
      <Route path="/search" element={<ProtectedRoute><SearchResults /></ProtectedRoute>} />
      <Route path="/subscribe" element={<ProtectedRoute><SubscriptionPlans /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      <Route path="/tv-shows" element={<ProtectedRoute><BrowsePage /></ProtectedRoute>} />
      <Route path="/movies" element={<ProtectedRoute><BrowsePage /></ProtectedRoute>} />
      <Route path="/new-popular" element={<ProtectedRoute><BrowsePage /></ProtectedRoute>} />
      <Route path="/my-list" element={<ProtectedRoute><BrowsePage /></ProtectedRoute>} />
      <Route path="/networking" element={<ProtectedRoute><NetworkingPage /></ProtectedRoute>} />
      <Route path="/profile/:userId" element={<ProtectedRoute><UserProfilePage /></ProtectedRoute>} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/account-settings" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <SchedulingFeatureProvider>
            <BrowserRouter>
              <AppRoutes />
              <Toaster />
            </BrowserRouter>
          </SchedulingFeatureProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;